<template>
    <div class="container admin-table-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{ labels.title }}</h2>
        </div>
        <b-row v-if="!isLoading">
            <div class="admin-table-block mt-4">
                <CorporateDataTable
                    :items="tasaTableItems"
                    :fields="allFields"
                    :filter-defs="tableFilterDefs"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                >
                    <template #toolbar-actions>
                        <b-button size="sm" class="table-toolbar-add-btn" @click="goToModalTasaCambio()">
                            {{ labels.create }}
                        </b-button>
                    </template>

                    <template #cell(vigencia)="data">
                        <div class="text-center">{{ data.item?.vigencia }}</div>
                    </template>

                    <template #cell(moneda)="data">
                        <div class="text-center">{{ data.item?.moneda }}</div>
                    </template>

                    <template #cell(tasa_cierre)="data">
                        <div class="text-center">{{ data.item?.tasa_cierre }}</div>
                    </template>

                    <template #cell(tasa_promedio)="data">
                        <div class="text-center">{{ data.item?.tasa_promedio }}</div>
                    </template>

                    <template #cell(tasa_interna)="data">
                        <div class="text-center">{{ data.item?.tasa_interna }}</div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click.stop="editarTasa(data.item)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                        </b-button>
                    </template>

                    <template #cell(accionDelete)="data">
                        <b-button
                            class="reset-btn-danger table-action-btn"
                            style="width: 30px; height: 30px; padding: 0; display: flex; align-items: center; justify-content: center;"
                            @click.stop="confirmDeleteTasa(data.item)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'trash']" size="xs"/></i>
                        </b-button>
                    </template>
                </CorporateDataTable>
            </div>
        </b-row>
        <b-row v-else>
            <b-col md="12" lg="12" class="p-4 mx-auto">
                <div class="text-center">
                    <b-spinner></b-spinner>
                </div>
            </b-col>
        </b-row>

        <NewTasaCambio :showDialog="showDialog" @clicked="closeModal" @created="onTasaCreada" />

        <b-modal
            :model-value="showDialogEdit"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            :title="labels.modalTitle"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-tasa-dialog"
         @hide="closeEditModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.validity }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.vigencia"
                            type="text"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.currency }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="formEdit.id_moneda"
                            class="form-input"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.selectCurrency }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="currency?.id" 
                                :value="currency?.id" 
                                v-for="currency in listCurrency"
                            >
                                {{ currency?.nombre }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.closingRate }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.tasa_cierre"
                            type="number"
                            step="0.0001"
                            class="form-input"
                            placeholder="Tasa de cierre"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.averageRate }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.tasa_promedio"
                            type="number"
                            step="0.0001"
                            class="form-input"
                            placeholder="Tasa promedio"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.internalRate }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.tasa_interna"
                            type="number"
                            step="0.0001"
                            class="form-input"
                            placeholder="Tasa interna"
                        />
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeEditModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="grabeTasa" :disabled="isLoading">
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <InacticaItem 
            :InactivaItem="showDeleteModal" 
            @confirmDelete="confirmDelete" 
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import TasaCambio from "@/services/TasaCambio"
import Currency from "@/services/Currency"
import CorporateDataTable from "../utils/CorporateDataTable.vue"
import NewTasaCambio from "../tasaCambio/NewTasaCambio.vue"
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "TasaCambio",
    components: {
        CorporateDataTable,
        NewTasaCambio,
        InacticaItem
    },
    data: () => ({
        tasaCambio: [],
        listCurrency: [],
        isLoading: false,
        showDialog: false,
        showDialogEdit: false,
        showDeleteModal: false,
        tasaToDelete: null,
        formEdit: {},
        error: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Tasas de Cambio",
                    create: "Crear Tasa",
                    validity: "Vigencia",
                    currency: "Moneda",
                    selectCurrency: "Seleccione una moneda",
                    closingRate: "Tasa Cierre",
                    averageRate: "Tasa Promedio",
                    internalRate: "Tasa Interna",
                    edit: "Editar",
                    delete: "Eliminar",
                    empty: "No hay tasas de cambio registradas",
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    filterValidity: "Filtrar vigencia...",
                    filterCurrency: "Filtrar moneda...",
                    save: "Guardar",
                    close: "Cerrar",
                    modalTitle: "Editar Tasa de Cambio",
                    infoTitle: "Datos de la tasa",
                    infoText: "Actualiza la información de la tasa de cambio."
                }
            } else {
                return {
                    title: "Exchange Rates",
                    create: "Create Rate",
                    validity: "Validity",
                    currency: "Currency",
                    selectCurrency: "Select a currency",
                    closingRate: "Closing Rate",
                    averageRate: "Average Rate",
                    internalRate: "Internal Rate",
                    edit: "Edit",
                    delete: "Delete",
                    empty: "No exchange rates registered",
                    noMatches: "No results found",
                    searchPlaceholder: "Search in table...",
                    rowsPerPage: "Rows per page:",
                    noSort: "No sorting",
                    sortAsc: "A-Z / Low to high",
                    sortDesc: "Z-A / High to low",
                    columns: "Columns",
                    showAllColumns: "Show all",
                    filters: "Filters",
                    clearFilters: "Clear filters",
                    filterValidity: "Filter validity...",
                    filterCurrency: "Filter currency...",
                    save: "Save",
                    close: "Close",
                    modalTitle: "Edit Exchange Rate",
                    infoTitle: "Rate information",
                    infoText: "Update the exchange rate information."
                }
            }
        },
        tasaTableItems() {
            return (this.tasaCambio || []).map((item) => ({
                ...item,
                moneda: this.getNameCurrency(item?.id_moneda)
            }))
        },
        allFields() {
            return [
                { key: 'vigencia', label: this.labels.validity, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'moneda', label: this.labels.currency, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'tasa_cierre', label: this.labels.closingRate, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'tasa_promedio', label: this.labels.averageRate, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'tasa_interna', label: this.labels.internalRate, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false },
                { key: 'accionDelete', label: this.labels.delete, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'vigencia', type: 'text', placeholder: this.labels.filterValidity },
                { key: 'moneda', type: 'text', placeholder: this.labels.filterCurrency }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.empty,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        
        goToModalTasaCambio() {
            this.showDialog = true
        },
        
        closeModal(value) {
            this.showDialog = value
        },

        onTasaCreada() {
            this.showDialog = false
            this.cargarTasas()
        },
        
        editarTasa(item) {
            if (this.isPeriodoBloqueado(item.vigencia)) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar')
                return
            }
            this.formEdit = { ...item }
            this.formEdit.nombre_moneda = this.getNameCurrency(item.id_moneda)
            this.formEdit.id_moneda = item.id_moneda
            this.showDialogEdit = true
        },
        
        closeEditModal() {
            this.showDialogEdit = false
            this.formEdit = {}
        },
        
        confirmDeleteTasa(item) {
            this.tasaToDelete = item
            this.showDeleteModal = true
        },
        
        closeDeleteModal() {
            this.showDeleteModal = false
            this.tasaToDelete = null
        },
        
        confirmDelete() {
            if (!this.tasaToDelete) return
            
            this.isLoading = true
            
            TasaCambio.deleteTasaCambio(this.tasaToDelete.id)
                .then(() => {
                    this.$toast.success(this.$store.state._language == "es-ES" 
                        ? "Tasa de cambio eliminada correctamente" 
                        : "Exchange rate deleted successfully")
                    this.showDeleteModal = false
                    this.tasaToDelete = null
                    this.cargarTasas()
                })
                .catch((error) => {
                    console.error(error)
                    this.$toast.error(this.$store.state._language == "es-ES" 
                        ? "Error al eliminar la tasa de cambio" 
                        : "Error deleting exchange rate")
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        
        getNameCurrency(id) {
            let objMoneda = this.listCurrency.find((obj) => obj.id === id)
            return objMoneda ? objMoneda.nombre : id
        },
        
        grabeTasa() {
            if (this.isPeriodoBloqueado(this.formEdit.vigencia)) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar')
                return
            }

            this.isLoading = true

            const payload = {
                ...this.formEdit,
                id: this.formEdit.id,
                idUser: this.$store.state.userId
            }

            console.log("PAYLOAD FRONT:", payload.tasa_cierre, payload.tasa_promedio, payload.tasa_interna)
            
            TasaCambio.grabeTasa(payload)
                .then(() => {
                    this.$toast.success("Información guardada correctamente")
                    this.showDialogEdit = false
                    this.cargarTasas()
                })
                .catch((error) => {
                    console.error(error)
                    this.$toast.error("Error al guardar la información")
                    this.error = true
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        
        isPeriodoBloqueado(vigencia) {
            if (!vigencia) return false
            return !this.$store.getters.isPeriodoEnabled(vigencia)
        },
        
        cargarTasas() {
            this.isLoading = true
            TasaCambio.getTasaCambio()
                .then((result) => {
                    this.tasaCambio = result.data.tasa || []
                })
                .catch((error) => {
                    console.error(error)
                    this.error = true
                    this.$toast.error("Error al cargar las tasas de cambio")
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    },
    mounted() {
        this.isLoading = true
        
        Promise.all([
            TasaCambio.getTasaCambio(),
            Currency.getAllCurrency()
        ])
        .then(([tasaRes, currencyRes]) => {
            this.tasaCambio = tasaRes.data.tasa || []
            this.listCurrency = currencyRes.data.currency || []
        })
        .catch((error) => {
            console.error(error)
            this.error = true
            this.$toast.error("Error al cargar los datos iniciales")
        })
        .finally(() => {
            this.isLoading = false
        })
    }
}
</script>

<style src="../main.css"></style>